import { useRef } from 'react'

const useLiveStates = (value) => {
  const state = useRef()
  state.current = value

  return state
}
export default useLiveStates
